import React, { useCallback } from "react";
import styled, { css } from "styled-components";
import { Timestamp } from "components/common";
import useRightSidebar from "hooks/useRightSidebar";
import { useGetSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import PaperSection from "security-app/components/Investigations/AIAgentTriageInvestigation/common/PaperSection";
import TriageStatus from "security-app/components/Investigations/AIAgentTriageInvestigation/common/TriageStatus";
import SelectedLogsTable from "./SelectedLogsTable";
const HeaderTitle = styled.span`
  display: inline-block;
  max-width: 760px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
`;
const HeaderActions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
  `
);
const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};
    margin-top: ${theme.spacings.md};
  `
);
const AnalysisBlock = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xxs};
  `
);
const AnalysisTitle = styled.h3`
  margin: 0;
`;
const Paragraph = styled.p`
  margin: 0;
`;
const EventSection = ({ event }) => {
  var _a, _b, _c;
  const { openSidebar } = useRightSidebar();
  const { securityEvent, loadingSecurityEvents } = useGetSecurityEvent(event.security_event_id);
  const eventMessage = (_b = (_a = securityEvent == null ? void 0 : securityEvent.event) == null ? void 0 : _a.message) != null ? _b : event.security_event_id;
  const eventTimestamp = (_c = securityEvent == null ? void 0 : securityEvent.event) == null ? void 0 : _c.timestamp;
  const onCollapse = useCallback(
    (wasOpened) => {
      if (!wasOpened) {
        openSidebar({
          id: `event-${event.security_event_id}`,
          title: "Event",
          componentKey: "EventReplaySideBarDetails",
          props: { alertId: event.security_event_id }
        });
      }
    },
    [event.security_event_id, openSidebar]
  );
  return /* @__PURE__ */ React.createElement(
    PaperSection,
    {
      title: event.security_event_id,
      header: /* @__PURE__ */ React.createElement(HeaderTitle, { title: eventMessage }, loadingSecurityEvents ? "Loading event..." : eventMessage),
      actions: /* @__PURE__ */ React.createElement(HeaderActions, null, /* @__PURE__ */ React.createElement(TriageStatus, { status: event.triage_status }), eventTimestamp && /* @__PURE__ */ React.createElement(Timestamp, { dateTime: eventTimestamp })),
      collapsible: true,
      defaultClosed: true,
      onCollapse
    },
    /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(AnalysisBlock, null, /* @__PURE__ */ React.createElement(AnalysisTitle, null, "Triage Summary"), /* @__PURE__ */ React.createElement(Paragraph, null, event.triage_summary)), event.replay_search && /* @__PURE__ */ React.createElement(AnalysisBlock, null, /* @__PURE__ */ React.createElement(AnalysisTitle, null, "Replay Search Analysis"), /* @__PURE__ */ React.createElement(Paragraph, null, event.replay_search.search_result_analysis)), event.event_procedure_searches.length > 0 && /* @__PURE__ */ React.createElement(AnalysisBlock, null, /* @__PURE__ */ React.createElement(AnalysisTitle, null, "Event Procedure Analysis"), event.event_procedure_searches.map(({ search_result_analysis }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React.createElement(Paragraph, { key: `${event.security_event_id}-procedure-analysis-${index}` }, search_result_analysis)
    ))), /* @__PURE__ */ React.createElement(AnalysisBlock, null, /* @__PURE__ */ React.createElement(AnalysisTitle, null, "Logs Added by Agent"), /* @__PURE__ */ React.createElement(SelectedLogsTable, { logs: event.selected_logs })))
  );
};
export default EventSection;
